//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Weld.js";
import "../no/TaggedObject.js";
import "../no/Section.js";
import "../GeometricUtilities/GeometricUtilities.OnPathDimensionBuilder.js";
import "../no/GeometricUtilities.js";
import "../no/Section.js";
let d=[[[1,"CustomSection",0,"Section",0],[1,"PathLocation",0,"GeometricUtilities.OnPathDimensionBuilder",0],[0,"RectangleBase",1,0],[0,"RectangleHeight",1,0],[0,"SemiMajor",1,0],[0,"SemiMinor",1,0],[0,"SizeString",1,0],[0,"ThroatThickness",1,0],[0,"TriangleBase",1,0],[0,"TriangleHeight",1,0],[0,"TriangleMethod",1,0],[0,"TriangleType",1,0],[0,"TubeDiameter",1,0]],[[[],"Validate",{R_:{result:''}},0,0]],[]];
SPLM.Weld.WeldBeadSizeBuilder = class extends SPLM.TaggedObject{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Weld.WeldBeadSizeBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Weld.WeldBeadSizeBuilder.Size = Object.freeze({
    "Default1" : "Default1", "Default2" : "Default2", "Default3" : "Default3", "Default4" : "Default4", "Default5" : "Default5", "Custom" : "Custom"});

SPLM.Weld.WeldBeadSizeBuilder.TriangleMethodType = Object.freeze({
    "LegLength" : "LegLength", "ThroatThickness" : "ThroatThickness"});

SPLM.Weld.WeldBeadSizeBuilder.TriangleTypes = Object.freeze({
    "OneSided" : "OneSided", "TwoSided" : "TwoSided"});

export default SPLM;